import { FC, ReactNode } from 'react'
import { InfoCircleOutlined } from '@ant-design/icons'
import classes from './index.module.css'
import { TooltipProps } from 'antd/es/tooltip'
import cn from 'classnames'
import TooltipWrapper from '@UI/New/TooltipWrapper/TooltipWrapper'

interface InfoCompProps
  extends Omit<
    TooltipProps,
    'title' | 'className' | 'children'
  > {
  text: ReactNode
  className?: string
  customIcon?: ReactNode
}

const InfoComp: FC<InfoCompProps> = ({
  text,
  className,
  customIcon,
  placement = 'top',
  overlayClassName,
  ...props
}) => {
  return (
    <div className={cn(classes.wrapper, className)}>
      <TooltipWrapper
        title={text}
        className={classes.tooltip}
        placement={placement}
        overlayClassName={cn(classes.tooltipOverlay, overlayClassName)}
        {...props}
      >
        {customIcon ? (
          customIcon
        ) : (
          <InfoCircleOutlined
            className={classes.icon}
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
          />
        )}
      </TooltipWrapper>
    </div>
  )
}

export default InfoComp
